import { ContainerFilled, ScheduleOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import "./StudentUpcomingAct.scss";
import { Spin, Empty } from "antd";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { EqEntityHorse } from "../../shared/interfaces/horse/IHorses";




interface ActivityProps {
    Activities: EqEntityHorse[];
    loading?: boolean;
}

interface FlatActivity {
    id: string;
    activityType: "task" | "training";
    date: Date;
    time: string;
    Imageurl: "ScheduleOutlined" | "ContainerFilled";
    dateCategory?: string;
}

const UpcommingActivity: React.FC<ActivityProps> = ({ Activities, loading }) => {
    const navigate = useNavigate();
    const [showAll, setShowAll] = useState(false);
  const { t, i18n } = useTranslation();

    const getIconComponent = (iconName: FlatActivity["Imageurl"]) => {
        if (iconName === "ScheduleOutlined") {
            return <ScheduleOutlined />;
        } else if (iconName === "ContainerFilled") {
            return <ContainerFilled />;
        } else {
            return null;
        }
    };

    const getDateCategory = (activityDate: Date): string => {
        const today = new Date();
        const tomorrow = new Date();
        today.setHours(0, 0, 0, 0);
        tomorrow.setHours(0, 0, 0, 0);
        tomorrow.setDate(today.getDate() + 1);

        const todayStr = today.toDateString();
        const tomorrowStr = tomorrow.toDateString();
        const activityStr = activityDate.toDateString();

        if (activityStr === todayStr) {
            return "today";
        } else if (activityStr === tomorrowStr) {
            return "tomorrow";
        } else {
            return "later";
        }
    };

    // Today's date at 00:00:00
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Flatten horseTasks and horseTrainings, filter by date
    const activitiesWithDateCategory: FlatActivity[] = Activities.flatMap((activity) => {
        const tasks = (activity.horseTasks || []).map((task): FlatActivity => {
            
            const dateObj = new Date(task.date);
            const timeObj = new Date(task.time);
            return {
                id: task.id,
                activityType: "task",
                date: dateObj,
                time: timeObj.toLocaleTimeString(),
                Imageurl: "ScheduleOutlined",
            };
        }).filter(task => task.date >= today);
        
        const trainings = (activity.horseTrainings || []).map((training): FlatActivity => {
            const dateObj = new Date(training.date);
            const timeObj = new Date(training.time);
            return {
                id: training.id,
                activityType: "training",
                date: dateObj,
                time: timeObj.toLocaleTimeString(),
                Imageurl: "ContainerFilled",
            };
        }).filter(training => training.date >= today);
        

        return [...tasks, ...trainings];
    });

    const sortedActivities = activitiesWithDateCategory
        .sort((a, b) => a.date.getTime() - b.date.getTime())
        .map((activity) => ({
            ...activity,
            dateCategory: getDateCategory(activity.date),
        }));

    const displayedActivities = showAll ? sortedActivities : sortedActivities.slice(0, 6);

    return (
        <div className="student-upcoming-card">
            <div className="top-heading-div">
                <h3>{t("upcomingHorseActivities")}</h3>
                <h3 onClick={() => navigate("/trainer/taskList")} className="Training-button">
                    {t("seeAllActivities")}
                </h3>
            </div>

            {loading ? (
                <Spin size="large" />
            ) : displayedActivities.length === 0 ? (
                <Empty description={t("noDataAvailable")} />
            ) : (
                displayedActivities.map((item) => (
                    <div className="cover-div" key={item.id}>
                        <div className="icon-wrapper">{getIconComponent(item.Imageurl)}</div>
                        <div className="activity-type">{t(item.activityType)}</div>
                        <div className="date-category">{t(item.dateCategory)}</div>
                        <div className="date-time">
                            {item.date.toLocaleDateString()} {t("at")} {item.time}
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default UpcommingActivity;
